import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../css/online-agent.scss";

import "react-multi-carousel/lib/styles.css";
import Techstacks from "./../../component/techstacks";

import onlineagent11x from "./../../images/onlineagent/onlineagent-1-1x.png";
import onlineagent12x from "./../../images/onlineagent/onlineagent-1-2x.png";
import onlineagent21x from "./../../images/onlineagent/onlineagent-2-1x.png";
import onlineagent22x from "./../../images/onlineagent/onlineagent-2-2x.png";
import onlineagent31x from "./../../images/onlineagent/onlineagent-3-1x.png";
import onlineagent32x from "./../../images/onlineagent/onlineagent-3-2x.png";
import onlineagent41x from "./../../images/onlineagent/onlineagent-4-1x.png";
import onlineagent42x from "./../../images/onlineagent/onlineagent-4-2x.png";
import onlineagent51x from "./../../images/onlineagent/onlineagent-5-1x.png";
import onlineagent52x from "./../../images/onlineagent/onlineagent-5-2x.png";

import imgConclusion from "./../../img/imgConclusion.svg";
import imgNumber1 from "./../../img/imgNumber1.svg";
import imgNumber2 from "./../../img/imgNumber2.svg";
import imgNumber3 from "./../../img/imgNumber3.svg";
import imgNumber4 from "./../../img/imgNumber4.svg";
import imgNumber5 from "./../../img/imgNumber5.svg";

function OnlineAgent(props) {

	const [onlineagent1WD, setOnlineagent1WD] = useState('');
	const [onlineagent2WD, setOnlineagent2WD] = useState('');
	const [onlineagent3WD, setOnlineagent3WD] = useState('');
	const [onlineagent4WD, setOnlineagent4WD] = useState('');
	const [onlineagent5WD, setOnlineagent5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setOnlineagent1WD(onlineagent11x);
		  setOnlineagent2WD(onlineagent21x);
		  setOnlineagent3WD(onlineagent31x);
		  setOnlineagent4WD(onlineagent41x);
		  setOnlineagent5WD(onlineagent51x);
	  } else if( props.wd >= 1200 ){
		  setOnlineagent1WD(onlineagent12x);
		  setOnlineagent2WD(onlineagent22x);
		  setOnlineagent3WD(onlineagent32x);
		  setOnlineagent4WD(onlineagent42x);
		  setOnlineagent5WD(onlineagent52x);
	  }
   },[props.wd]);
  
  return (

      <div>
        <Container>
          <div className="wrapBG">
            <Row className="wrapRowOnlineAgent1">
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2APISalesTool">
                  <span className="h2ChatBotsTextBlue">Онлайн</span> Агент
                </h2>
                <p className="pChatBotsText">
                  Ми відмінно вміємо створювати процеси, спрямовані на залучення нових клієнтів для страхових компаній через стратегічне впровадження реферальної програми та інноваційних ІТ-рішень.
                </p>
                <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={onlineagent1WD}
                    alt=" "
                    className="imgOnlineAgent1"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent2">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2TechStacksText">Технічні стеки</h2>
              </Col>
            </Row>
            <Row className="wrapRowTechStacksImg">
              <Col xl="12" lg="12" md="12" sm="12">
                <div id="marquee1" className="marquee">
                  <div id="blockSlider" className="marquee__inner">
                    <Techstacks />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ЗАВДАННЯ КЛІЄНТА</h2>
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent4">
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pCustomerProblems">
                  Метою Страхової компанії було створення реферальної програми для приваблення нових клієнтів.
                  <br/>
                  <br/>
                  Функціональні можливості реферальної програми включали:
                </p>
                <ul className="ulCustomerProblems">
                  <li> <b>Швидке підключення агентів. </b>
                    Процес залучення потенційних агентів мав бути завершений за кілька хвилин без необхідності розуміння складних страхових концепцій.</li>
                  <li> <b>Операції онлайн для агентів. </b>
                    Очікувалося, що агенти будуть повністю працювати онлайн, без необхідності відвідування фізичного офісу компанії.
                  </li>
                  <li> <b>Зручне подання потенційного клієнта. </b>
                    Навіть якщо потенційний клієнт просто хотів би порекомендувати лід страховій компанії та отримати комісію, ця дія повинна бути простою, швидкою і зручною.</li>
                  <li><b>Доступність для експертів, які не займаються ІТ. </b>
                    Потенційним агентам, включаючи осіб, які не звикли до IT-світу, повинно бути легко розуміти та працювати з IT-рішеннями страхової компанії.</li>
                  <li> <b>Оптимізована передача потенційного клієнта. </b>
                    Агенти повинні витрачати не більше кількох хвилин на подання ліда, а страхова компанія бере на себе відповідальність за подальшу взаємодію з клієнтом.
                  </li>
                </ul>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={onlineagent2WD}
                    alt=" "
                    className="imgOnlineAgent2"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent5">
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="imgApiSalesTool2Top"
              >
                <img
                    src={onlineagent3WD}
                    alt=" "
                    className="imgOnlineAgent3"
                />
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pAPISalesTool2">
                  Для реалізації цього процесу було прийнято рішення розробити сторінку для подачі лідів (потенційних нових клієнтів) на веб-сайті страхової компанії. Ця цільова сторінка містила б рекламний контент і посилання на чат-бот, за допомогою якого потенційні агенти зможуть взаємодіяти зі страховою компанією на всіх етапах реферальної програми.
                  <br />
                  <br />
                  Чат-бот надав би можливість агентам:
                  <br />- Ініціювати зв'язок із страховою компанією.
                  <br />- Подавати потенційні ліди страховій компанії.
                  <br />- Відстежувати статус транзакцій, пов'язаних із їхніми лідами.
                  <br />- Звертатися за консультацією до фахівців страхової компанії.
                  <br />
                  <br />
                  Для побудови такого процесу потрібна була інтеграція чат-бота з CRM компанії, веб-сайтом та іншими внутрішніми системами.
                </p>
              </Col>
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="imgApiSalesTool2Bottom"
              >
                <img
                    src={onlineagent3WD}
                    alt=" "
                    className="imgOnlineAgent3"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent6">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ПРОЦЕС РОЗРОБКИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessBlock">
              <Col xl="12" lg="12" md="12" sm="12">
                <div className="itemImgNumber itemImgNumber1">
                  <img
                      src={imgNumber1}
                      alt=""
                      className="imgNumber imgNumber1"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Концепція рішення та визначення проблеми:</b>
                    <br/>- Співпраця з клієнтом для визначення загальної концепції рішення та визначення основних проблем, які потрібно вирішити. Цей етап ляже в основу проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber2">
                  <img
                      src={imgNumber2}
                      alt=""
                      className="imgNumber imgNumber2"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Регулярні зустрічі для виведення статусу:</b>
                    <br/>- Проведення щотижневих зустрічей для виведення статусу зі спонсором проекту та ключовими членами робочої групи. Ці зустрічі служать платформою для постійного спілкування та вирівнювання з метою проекту.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber3">
                  <img
                      src={imgNumber3}
                      alt=""
                      className="imgNumber imgNumber3"
                  />
                  <p className="pDevelopmentProcess">
                    <b>План дій та узгодження концепцій:</b>
                    <br/>- Розроблення планів дій та узгодження концепцій рішення та макетів. Цей ітераційний процес допомагає створити спільне бачення та розуміння напрямку рішення.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber4">
                  <img
                      src={imgNumber4}
                      alt=""
                      className="imgNumber imgNumber4"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Демонстрація прогресу розробки:</b>
                    <br/>- Показ проміжних результатів розробки клієнту та зацікавленим сторонам проекту. Цей процес забезпечує прозорість та дозволяє отримати ранній зворотний зв'язок та внести корективи.
                  </p>
                </div>
                <div className="itemImgNumber itemImgNumber5">
                  <img
                      src={imgNumber5}
                      alt=""
                      className="imgNumber imgNumber5"
                  />
                  <p className="pDevelopmentProcess">
                    <b>Планування масштабованості:</b>
                    <br/>- Обговорення та коригування планів масштабованості для майбутнього рішення. Масштабованість має важливе значення для врахування зростаючого попиту та змін у страховій галузі.
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent7">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">РЕЗУЛЬТАТИ</h2>
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent5">
              <Col xl="6" lg="6" md="12" sm="12">
                <p className="pOnlineAgent">
                  Весь процес був розділений на дві фази:
                  <br />
                  - MVP
                  <br />
                  - Цільовий процес
                  <br />
                  <br />
                  Фаза MVP спрямована на встановлення мінімального набору розробок для перевірки процесу на реальних сценаріях. Основна мета полягала в тому, щоб процес виглядав близьким до цільового стану з самого початку та вимагав мінімальних коригувань у майбутньому.
                  <br />
                  <br />
                  Отже, MVP охоплював повну розробку чат-бота та його інтеграцію з CRM-системою та веб-сайтом. Розробка внутрішньої інфраструктури та додаткової автоматизації процесів була відкладена на другу фазу.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                    src={onlineagent4WD}
                    alt=" "
                    className="imgOnlineAgent4"
                />
              </Col>
            </Row>
            <Row className="wrapRowOnlineAgent8">
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="imgApiSalesTool2Top"
              >
                <img
                    src={onlineagent5WD}
                    alt=" "
                    className="onlineagent5WD"
                />
              </Col>
              <Col xl={{ offset: 1, span: 5 }} lg={{ offset: 1, span: 5 }} md="12" sm="12">
                <p className="pOnlineAgent">
                  Фаза розробки тривала 3 місяці, причому перша фаза тривала всього один місяць. Цей ефективний підхід дозволив нам швидко запустити систему та оцінити її функціонал.
                  <br />
                  <br />
                  Команда успішно розробила рішення, яке повністю відповідало всім вказаним вимогам клієнта. Після цього ми провели навчання співробітників клієнта та запустили систему.
                  <br />
                  <br />
                  Страхова компанія почала отримувати ліди від потенційних агентів вже першого дня після запуску розробки. Таке швидке впровадження продемонструвало ефективність системи.
                </p>
              </Col>
              <Col
                  xl="6"
                  lg="6"
                  md="12"
                  sm="12"
                  className="imgApiSalesTool2Bottom"
              >
                <img
                    src={onlineagent5WD}
                    alt=" "
                    className="imgOnlineAgent45"
                />
              </Col>
            </Row>
            <Row className="wrapRowDevelopmentProcessText">
              <Col xl="12" lg="12" md="12" sm="12">
                <h2 className="h2DevelopmentProcess">ВИСНОВОК</h2>
              </Col>
            </Row>
            <Row className="wrapRowConclusion">
              <Col xl="6" lg="6" md="12" sm="12">
                <div className="wrapConclusionText">
                  <p className="pConclusion">
                    Цей результат є переконливим прикладом того, як навіть під час таких викликів як карантин, запуск нових рішень може ефективно допомагати страховим компаніям залучати нових клієнтів. Особливо варто відзначити, що це рішення має додаткову перевагу у тому, що воно дозволяє людям без попереднього досвіду в страхуванні генерувати додатковий дохід.
                    <br/>Це підкреслює цінність інновацій та адаптивності для трансформації взаємодії з клієнтами та бізнес-операцій.
                  </p>
                  <a href="/ua/contact" className="btn buttonOne">Зв'язатися</a>
                </div>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={imgConclusion} alt="" className="imgConclusion" />
              </Col>
            </Row>
          </div>
        </Container>
      </div>

  );
}

export default OnlineAgent;
